import CoreAPIClientError from "@/api/core/CoreAPIClientError";
import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import { UpdateUserGlobalRolesCommandResult } from "@ternary/api-lib/core/commands/UpdateUserGlobalRolesCommand";
import { useCoreRequestSender } from "../../../api/CoreRequestSenderProvider";

const FAILED_UPDATING_USER_GLOBAL_ROLES = "FAILED_UPDATING_USER_GLOBAL_ROLES";

type UpdateUserGlobalRolesParams = {
  userID: string;
  roles: string[];
};

type Options = UseMutationOptions<
  string,
  CoreAPIClientError,
  UpdateUserGlobalRolesParams
>;

type Result = UseMutationResult<
  string,
  CoreAPIClientError,
  UpdateUserGlobalRolesParams
>;

export function useUpdateUserGlobalRoles(options?: Options): Result {
  const sender = useCoreRequestSender();

  return useMutation({
    mutationFn: async (params) => {
      try {
        const result = (await sender.send(`/user-roles/global`, {
          method: "PATCH",
          body: params,
        })) as UpdateUserGlobalRolesCommandResult;

        return result.userID;
      } catch (error) {
        console.error(error);

        throw new CoreAPIClientError(FAILED_UPDATING_USER_GLOBAL_ROLES);
      }
    },
    ...options,
  });
}
